import { render, staticRenderFns } from "./MultipleBar.vue?vue&type=template&id=6b39c662&"
import script from "./MultipleBar.vue?vue&type=script&lang=js&"
export * from "./MultipleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports